export const getIsFetching = state => state.user.isFetching;
export const getErrorMessage = state => state.user.errorMessage;
